module.exports = __webpack_public_path__ + "pic_bizny_web_06-640@2x.png?00544f30670b222a6697868afa40e3d4";